import React from "react";
import PaneRow from "../../models/PaneRow";

interface TableContextValue {
  visibleRows: PaneRow[];
}

export const TableContext = React.createContext<TableContextValue>({
  visibleRows: [],
});

export const TableProvider: React.FC<{
  children: React.ReactNode;
  visibleRows: PaneRow[];
}> = (props) => (
  <TableContext.Provider
    value={{
      visibleRows: props.visibleRows,
    }}
  >
    {props.children}
  </TableContext.Provider>
);
